import { cn } from "../lib/utils";
import React from "react";
/**
 * A vertically stacked list of settings, where each `SettingsList.Row` pairs a `title`
 * and optional `description` with a trailing `action` control; the container handles
 * dividers and spacing. Use it for a settings or preferences panel where each row exposes
 * a single labelled control. For list rows that need a leading visual or hover-revealed
 * controls, use `ContextItem` instead. Pass `title` (and optionally `description`) to render
 * a section heading above the list with consistent spacing.
 *
 * @summary Stacked list of settings rows.
 */
export function SettingsList({
  children,
  title,
  description,
  className,
  density = "comfortable"
}) {
  const list = /*#__PURE__*/React.createElement("div", {
    className: cn("flex flex-col overflow-hidden rounded-2xl border border-border divide-y divide-border", density === "compact" ? "[--settings-list-row-padding:0.75rem]" : "[--settings-list-row-padding:1rem]", className)
  }, children);
  if (!title) {
    return list;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-0.5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading-base flex items-center gap-1 text-foreground"
  }, title), description && /*#__PURE__*/React.createElement("div", {
    className: "copy-sm text-muted-foreground"
  }, description)), list);
}
function SettingsListRow({
  icon,
  title,
  description,
  action,
  className
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: cn("flex items-center justify-between gap-4 px-4 py-[var(--settings-list-row-padding,1rem)]", className)
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: "shrink-0"
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 flex-col gap-0.5 grow-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "heading-sm text-foreground"
  }, title), description && /*#__PURE__*/React.createElement("span", {
    className: "copy-sm text-muted-foreground"
  }, description)), action && /*#__PURE__*/React.createElement("div", {
    className: "shrink-0"
  }, action));
}
SettingsList.Row = SettingsListRow;
//# sourceMappingURL=SettingsList.js.map